import { parse, stringify } from "qs";

export const qs = {
  parse,
  stringify: (obj: Record<string, unknown> | undefined | null): string =>
    obj ? "?" + stringify(obj, { arrayFormat: "brackets", encode: false }) : "",
};
